import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { concatMap, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import {
  supplierPartnerCouponHistoryRequest,
  supplierPartnerCouponHistoryResponse,
  supplierPartnerCouponListRequest,
  supplierPartnerCouponListResponse,
  supplierPartnerCouponProductRequest,
  supplierPartnerCouponProductResponse,
  supplierPartnerCouponViewRequest,
  supplierPartnerCouponViewResponse
} from './supplier-partner-coupon.actions';
import { SupplierPartnerCouponService } from '../services/supplier-partner-coupon.service';

@Injectable()
export class SupplierPartnerCouponEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private supplierPartnerCouponService: SupplierPartnerCouponService
  ) {}

  supplierPartnerCouponListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(supplierPartnerCouponListRequest),
      tap((_) =>
        this.logger.debug(
          '@Effect [SupplierPartnerCoupon] SupplierPartnerCoupon list request : ',
          JSON.stringify(_.payload)
        )
      ),
      switchMap(({ payload }) => {
        return this.supplierPartnerCouponService.getSupplierPartnerCouponList(payload).pipe(
          map((response) => {
            return supplierPartnerCouponListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  supplierPartnerCouponViewRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(supplierPartnerCouponViewRequest),
      tap((_) => this.logger.debug('@Effect [SupplierPartnerCoupon] SupplierPartnerCoupon view request')),
      switchMap((payload) => {
        return this.supplierPartnerCouponService
          .getSupplierPartnerCouponView({
            offerCampaignNo: payload.offerCampaignNo || '',
            redeemCampaignNo: payload.redeemCampaignNo || ''
          })
          .pipe(
            map((response) => {
              return supplierPartnerCouponViewResponse({ response });
            }),
            catchError((err) => of(err))
          );
      })
    );
  });

  supplierPartnerCouponHistoryRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(supplierPartnerCouponHistoryRequest),
      tap((_) => this.logger.debug('@Effect [SupplierPartnerCoupon] SupplierPartnerCoupon history request')),
      switchMap((payload) => {
        return this.supplierPartnerCouponService
          .getSupplierPartnerCouponHistory({
            offerCampaignNo: payload.offerCampaignNo || '',
            redeemCampaignNo: payload.redeemCampaignNo || ''
          })
          .pipe(
            map((response) => {
              return supplierPartnerCouponHistoryResponse({ response: response.auditLogs });
            }),
            catchError((err) => of(err))
          );
      })
    );
  });

  supplierPartnerCouponProductRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(supplierPartnerCouponProductRequest),
      tap((_) => this.logger.debug('@Effect [SupplierPartnerCoupon] SupplierPartnerCoupon product request')),
      concatMap((payload) => {
        return this.supplierPartnerCouponService.getSupplierPartnerCouponProduct(payload.payload).pipe(
          map((response) => {
            return supplierPartnerCouponProductResponse({ response: response, usage: payload.payload.usage });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
